import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import illusStep3 from "../../images/illustrations/illus-step3.png";
import { useStoreShareFunction } from "../../store/StoreShareFunction";
import "../../styles/components/addResidencePart/step12Finish.css";
const currentStep = 12;

export default function StepTwelveFinish({ step, handleBlockBtn }) {
  const { t } = useTranslation();
  useEffect(() => {
    if (currentStep == step) handleBlockBtn(false);
  }, [step]);

  const handleKeyDown = (e) => {
    if (e.key == "Enter" && currentStep == step) {
      document.activeElement.blur();
      useStoreShareFunction.getState().nextPage();
    }
  };
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [step]);
  return (
    <section
      className={`step-1-annonce step-12 ${
        currentStep == step ? "visible" : ""
      } 
          ${currentStep < step ? "go-top" : ""} ${
        currentStep > step ? "go-bottom" : ""
      } add-resi add-resi-input | relve`}
    >
      <div className="contains |  max-container flrow liner">
        <div className="left-part-add-resi | flcolm jcenter">
          <div className="content | flcolm jcenter">
            <span className="step">{t("addResidence.step12.title")}</span>
            <label>{t("addResidence.step12.label")}</label>
            <p>{t("addResidence.step12.description")}</p>
          </div>
        </div>
        <div className="right-part-add-resi | flcolm jcenter liner">
          <img src={illusStep3} alt="illustration" />
        </div>
      </div>
    </section>
  );
}
